import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  row1: {
    flexDirection: 'row'
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnContent: {
    width: '15%',
    padding: 4,
    textAlign: 'center',
    alignItems: 'center'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);
const COLORS = ['#ffffff', '#e0e0e0'];
export const IPDBillingPDF = ({ data }) => {
  console.log(data);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const user = JSON.parse(localStorage.getItem('user'));
  const currentDate = new Date();
  // Get date components
  const day = currentDate.getDate().toString().padStart(2, '0');
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
  const year = currentDate.getFullYear();

  // Get time components
  const hours = currentDate.getHours().toString().padStart(2, '0');
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const seconds = currentDate.getSeconds().toString().padStart(2, '0');

  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title={`Ipd Service Invoice`}>
        <Page size="A4" style={styles.page}>
          <PDFImage
            src="/logo_Hospital_m.jpeg"
            style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
          />
          <View style={styles.row}>
            <Text content="IPD Bill" style={{ fontSize: '12px', margin: '0 auto' }} />
          </View>
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Reciept No.   :   " style={styles.textBold} />
                <Text content={`${data.receiptNo}`} />
              </View>
              <View style={styles.row}>
                <Text content="UHID NO.      :   " style={styles.textBold} />
                <Text content={`${data.uhid}`} />
              </View>
              <View style={styles.row}>
                <Text content="Date/Time     :   " />
                <Text content={`${formatDate(data?.billing_date)} ${data?.billing_time}`} />
              </View>
              <View style={styles.row}>
                <Text content="Doctor           :   " />
                <Text content={`${data.consultant.doctor}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Patient Name    :   " />
                <Text content={`${data.patientName}`} />
              </View>
              <View style={styles.row}>
                <Text content="Age/Sex            :   " />
                <Text content={`${data.age} / ${data.gender}`} />
              </View>
              <View style={styles.row}>
                <Text content="Mobile               :   " />
                <Text content={`${data.mobile}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Department   :   " />
                <Text content={`${data.department}`} />
              </View>
              <View style={styles.row}>
                <Text content="Sponsor        :   " />
                <Text content={`${data.sponsor}`} />
              </View>
              <View style={styles.row}>
                <Text content="Address         :   " />
                <Text content={`${data.address}`} />
              </View>
            </View>
          </View>

          {/* Table */}

          <View style={styles.row1}>
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Sr No." />
            <Text style={{ ...styles.columnHeader, width: '40%' }} content="Services" />
            <Text style={{ ...styles.columnHeader, width: '5%' }} content="Qty" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Rate" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Amount" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Disc" />
            <Text style={{ ...styles.columnHeader, width: '15%' }} content="Net Amount" />
          </View>
          {data.services &&
            data?.services?.map((service, index) => (
              <View key={index} style={{ ...styles.row1, backgroundColor: COLORS[index % COLORS.length] }}>
                <Text style={{ ...styles.columnContent, width: '10%' }} content={index + 1} />
                <Text
                  style={{
                    ...styles.columnContent,
                    width: '40%',
                    textAlign: 'left',
                    flexWrap: 'wrap',
                    overflow: 'hidden'
                  }}
                  content={service.service_name}
                />
                <Text style={{ ...styles.columnContent, width: '5%' }} content={`${service.quantity}`} />
                <Text style={{ ...styles.columnContent, width: '10%', textAlign: 'right' }} content={service.rate} />
                <Text style={{ ...styles.columnContent, width: '10%', textAlign: 'right' }} content={service.amount} />
                <Text
                  style={{ ...styles.columnContent, width: '10%', textAlign: 'right' }}
                  content={service.disc_amt}
                />
                <Text
                  style={{ ...styles.columnContent, width: '15%', textAlign: 'right', marginRight: '10px' }}
                  content={service.net_amt}
                />
              </View>
            ))}
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              {/* <View style={styles.row}>
                <Text content="Total Amount  :   " style={styles.textBold} />
                <Text content={`${data.total_amt}`} />
              </View> */}
              {/* <View style={styles.row}>
                <Text content="Net Amt          :   " style={styles.textBold} />
                <Text content={`${data.net_amt}`} />
              </View> */}
              <View style={{ ...styles.row, marginTop: '26px' }}>
                <Text content="Remarks  :    " style={styles.textBold} />
                <Text content={`${''}`} />
              </View>
              <View style={{ marginTop: 20 }}>
                <Text content={`Recieved With Thanks From : ${data.patientName}.`} style={{ width: '320px' }} />
              </View>
              <View style={{ marginTop: '15px' }}>
                <Text
                  content={'Note : Refurd if any, will be made against surrender of Original Receipt only !'}
                  style={{ width: '320px' }}
                />
              </View>
            </View>
            <View style={styles.column}>
              {/* <View style={styles.row}>
                <Text content="Service Discount  :  " />
                <Text content={`${data.service_disc}`} />
              </View> */}
              <View style={styles.row}>
                {data.pay_mode === 'CASH' ? (
                  <>
                    <div>
                      <Text content="Cash                    :  " />
                    </div>
                    <div>
                      <Text content={`${data.rec_amt_1}`} />
                    </div>
                  </>
                ) : (
                  ['Bank', 'UPI', 'Paytm', 'RTGS/NEFT', 'Cheque', 'Credit Card', 'Debit Card', 'Both'].includes(
                    data.pay_mode
                  ) && (
                    <>
                      {data.pay_mode === 'Both' && (
                        <>
                          <div>
                            <Text content="Cash                    :   " />
                          </div>
                          <div>
                            <Text content={`${data.rec_amt_1}    `} />
                          </div>
                        </>
                      )}
                      <div>
                        <Text content="  Bank  :" />
                      </div>
                      <div>
                        <Text content={`${data.rec_amt_2}`} />
                      </div>
                    </>
                  )
                )}
                {data.pay_mode === 'Credit' && (
                  <>
                    <>
                      <div>
                        <Text content="Cash                    :   " />
                      </div>
                      <div>
                        <Text content={`${data.rec_amt_1}    `} />
                      </div>
                    </>

                    <div>
                      <Text content="  Bank  :" />
                    </div>
                    <div>
                      <Text content={`${data.rec_amt_2}`} />
                    </div>
                  </>
                )}
              </View>
              <View style={styles.row}>
                <Text content="Payment Mode     :   " />
                <Text content={`${data.pay_mode}`} />
              </View>
              <View style={{ ...styles.row, marginTop: '10px' }}>
                <Text content="Printed By : " style={styles.textBold} />
                <Text content={`${user.name}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Total Amount            :   " style={styles.textBold} />
                <Text content={`${data.total_amt}`} />
              </View>
              <View style={styles.row}>
                <Text content="Bill Discount             :    " />
                <Text content={`${data.disc_amt}`} />
              </View>
              <View style={styles.row}>
                <Text content="Service Discount      :    " />
                <Text content={`${data.service_disc}`} />
              </View>
              <View style={styles.row}>
                <Text content="Net Amt                    :   " style={styles.textBold} />
                <Text content={`${data.net_amt}`} />
              </View>
              <View style={styles.row}>
                <Text content="Balance Amt            :    " />
                <Text content={`${data.balance_amt}`} />
              </View>

              <View style={{ marginTop: '20px' }}>
                <Text content="Recieved By  :" />
                <Text style={styles.textUnderlined} />
              </View>
              <View style={{ marginTop: '20px' }}>
                <Text content="Authorised Signatory  :" />
                <Text style={styles.textUnderlined} />
                <View style={{ marginTop: '12px' }}>
                  <Text
                    content={`Printed Date and Time - ${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`}
                    style={{ width: '180px' }}
                  />
                </View>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
